var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabletSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 2H5.625C4.45139 2 3.5 2.89543 3.5 4V20C3.5 21.1046 4.45139 22 5.625 22H18.375C19.5486 22 20.5 21.1046 20.5 20V4C20.5 2.89543 19.5486 2 18.375 2Z",
    stroke: "url(#paint0_linear_7140_23528)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H12.01",
    stroke: "url(#paint1_linear_7140_23528)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7140_23528",
    x1: 16.7093,
    y1: 5.01168,
    x2: 6.56737,
    y2: 17.9162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EC7ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8627EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7140_23528",
    x1: 12.0078,
    y1: 18.1506,
    x2: 11.9921,
    y2: 18.1508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EC7ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8627EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletSelected);
export default __webpack_public_path__ + "static/media/tablet-selected.95854a0ff9755d85a123e80a2b463f86.svg";
export { ForwardRef as ReactComponent };